import { formatCurrency } from "src/shared/hooks/formatCurrency"
import Table from "../../PDFTable/Table/Table"
import Row from "../../PDFTable/Row/Row"
import Cell from "../../PDFTable/Cell/Cell"
import { v4 as uuid } from "uuid"
import { styles } from "../../TicketCaratula/TicketCaratulaStyles"
import { useEffect, useState } from "react"

const Gastos = ({ cortes_pdf, desglose = false }) => {
    const [totalGastos, setTotalGastos] = useState(0)

    useEffect(() => {
        if (cortes_pdf) {
            const total = cortes_pdf.gastos.reduce((acc, gasto) => acc + parseFloat(gasto.total), 0)
            setTotalGastos(total)
        }
    }, [cortes_pdf])

    if (desglose) {
        return (
            <Table style={{ marginTop: "5px", border: "0.5px solid var(--placeholder)" }}>
                <Row fixed backgroundColor="#eaecf0">
                    <Cell width="64%" textStyle={{ fontWeight: 600, fontSize: 8 }}>
                        Concepto
                    </Cell>
                    <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                        Cantidad
                    </Cell>
                    <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                        Monto total
                    </Cell>
                </Row>
                {cortes_pdf?.gastos.map((gasto, index) => (
                    <Row backgroundColor={index % 2 !== 0 ? "#f2f4f7" : ""} key={uuid()}>
                        <Cell width="64%" textStyle={{ fontSize: 7 }}>
                            {gasto.subcategoria}
                        </Cell>
                        <Cell width="18%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                            1
                        </Cell>
                        <Cell width="18%" textStyle={{ textAlign: "right", fontSize: 7 }}>
                            {formatCurrency(Number(gasto.total) || 0)}
                        </Cell>
                    </Row>
                ))}
                <Row style={styles.cell_totales}>
                    <Cell width="64%" textStyle={{ fontWeight: 600, fontSize: 7 }}>
                        Total
                    </Cell>
                    <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                        {cortes_pdf?.gastos?.length ?? 0}
                    </Cell>
                    <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                        {formatCurrency(totalGastos)}
                    </Cell>
                </Row>
            </Table>
        )
    }

    return (
        <Table style={{ border: "0.5px solid var(--placeholder)" }}>
            <Row fixed backgroundColor="#eaecf0">
                <Cell width="64%" textStyle={{ fontWeight: 600, fontSize: 8 }}>
                    Gastos de fondo de caja
                </Cell>
                <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                    #
                </Cell>
                <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 8, textAlign: "right" }}>
                    Total
                </Cell>
            </Row>
            <Row style={styles.cell_totales}>
                <Cell width="64%" textStyle={{ fontWeight: 600, fontSize: 7 }}>
                    Total
                </Cell>
                <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                    {cortes_pdf?.gastos?.length ?? 0}
                </Cell>
                <Cell width="18%" textStyle={{ fontWeight: 600, fontSize: 7, textAlign: "right" }}>
                    {formatCurrency(totalGastos)}
                </Cell>
            </Row>
        </Table>
    )
}

export default Gastos
